<template>
	<div class="row wrapper">
        <div class="image_login col-lg-7">
            <div class="container">
                <img src="../assets/image/login-img.png" class="login_img" alt="">
            </div>
        </div>
        <div class="login_form col-lg-5 my-auto">
            <div class="container">
                <h1 class="title">
                    Reset <br>
                    Password
                </h1>

                <div class="spacer-lg"></div>
                
                <form name="form" @submit.prevent="handleReset()">
                    <div class="form-group">
                        <div v-if="message" class="alert alert-danger" role="alert">{{message.message}}</div>
                    </div>
                    <div class="form-group">
                        <div class="input">
                            <input type="password" v-model="new_password" v-validate="'required|min:6|max:40'" ref="new_password" name="new_password" data-vv-as="New Password" class="form-control field-password" placeholder="New Password">
                            <i class='bx bx-lock'></i>
                            <div class="input-group-append show_pass">
                                <span class="input-group-text"><i @click="showPassword" class="eye-icon bi bi-eye"></i></span>
                            </div>
                        </div>
                        <div v-if="submitted && new_password == ''" class="text-danger">
                            New Password Required
                        </div>
                        <div v-else-if="submitted && new_password.length <8" class="text-danger">
                            The New Password must be at least 8 characters
                        </div>
                        <div v-else-if="submitted && errors.has('new_password')" class="text-danger">
                            {{errors.first('new_password')}}
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input">
                            <input type="password" v-model="confirm_password" v-validate="'required|confirmed:new_password'" data-vv-as="New Password" name="confirm_password" class="form-control field-password-confirm" placeholder="New Password Confirmation">
                            <i class='bx bx-lock'></i>
                            <div class="input-group-append show_pass2">
                                <span class="input-group-text"><i @click="showPasswordconfirm" class="eye-icon bi bi-eye eye_open"></i></span>
                            </div>
                        </div>
                        <div v-if="submitted && confirm_password == ''" class="text-danger">
                            New Password Confirmation required
                        </div>
                        <div v-else-if="submitted && errors.has('confirm_password')" class="text-danger">
                            {{errors.first('confirm_password')}}
                        </div>
                    </div>
					<div class="row">
						<!-- <div class="col-4">
							<router-link to="/login" class="btn btn_outline_red btn-block">Cancel</router-link>
						</div> -->
						<div class="col-12">
							<button class="btn btn_red btn-block" type="submit" id="btn-reset" :disabled="loading">
								<span v-show="loading" class="spinner-border spinner-border-sm"></span>
								<!-- <img v-show="!loading" src="../assets/image/login_icon.svg" class="mr-2" alt=""> -->
								<span v-show="!loading">Reset Password</span>
							</button>
						</div>
					</div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
export default {
	data() {
		return {
			new_password: '',
            confirm_password: '',
            reset_token: this.$route.query.token,
            message: '',
			loading: false,
            submitted: false,
		}
	},
	methods : {
        showPassword() {
            const input = document.querySelector('.field-password')
            const show = document.querySelector('.eye-icon')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
        showPasswordconfirm() {
            const input = document.querySelector('.field-password-confirm')
            const show = document.querySelector('.eye_open')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
		handleReset() {
			this.submitted = true;
			this.loading = true;
			document.getElementById("btn-reset").disabled = true;
			if(this.new_password.length < 8 ) {
                document.getElementById("btn-reset").disabled = false
                    swal('oops..', 'Minimum password length is 8 characters', 'error', {
                    button: "OK"
                })
            }
            else if(this.new_password == this.confirm_password){
                const data = new FormData()
                
                data.append('new_password', this.new_password)
                data.append('reset_token', this.reset_token)
    
                axios.post("investor/auth/resetpassword/", data)
                .then(() => {
                    this.loading = false;
                    document.getElementById("btn-reset").disabled = false
                    swal('Password Reset Has Been Successfully Done', 'Please login to do the next process', 'success', {
                        button: "OK"
                    })
                    this.$router.push({ path: `/login` })
                }).catch(()=>{
                    this.loading = false;
                    document.getElementById("btn-reset").disabled = false
                    // console.log(error)
                    swal('Email Not Found', 'Please check your email again', 'error', {
                        button: "OK"
                    })
                })
                this.loading = false
            }else{
                document.getElementById("btn-reset").disabled = false
                swal('Oops..', 'The password you entered is not the same', 'error', {
                    button: "OK"
                })
            }
            this.loading = false;

            // this.$validator.validate().then(isValid => {
            //     if(isValid){
            //         console.log(this.new_password)
                    
            //     } else{
            //         this.loading = false;
            //         this.submitted = false;
            //     }
            // })

		}
	}
}
</script>

<style>

</style>